import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { useLocation } from 'react-router-dom'

import Section from 'components/Section'
import Loader from 'components/Loader'
import ItemDetails from 'components/Item/Form'
import Item from 'components/Item/Item'

const ItemList = ({
  data,
  itemsSelected,
  setItemsSelected,
  isLoading,
}) => {
  const { state: urlQueryParamsState } = useLocation()

  const isModal = !isEmpty(urlQueryParamsState?.itemUuid)

  const isItemChecked = (uuid) => itemsSelected?.includes(uuid)

  const handleSelectItem = useCallback((checked, uuid) => {
    const unselectItem = (selectedItems) =>
      selectedItems.filter((selectedUuid) => selectedUuid !== uuid)

    checked
      ? setItemsSelected((selectedItems) =>
          unselectItem(selectedItems)
        )
      : setItemsSelected((selectedItems) => [...selectedItems, uuid])
    // eslint-disable-next-line
  }, [])

  // we won't show loader on the list when modal is open
  const isLoadingItems = isLoading && !isModal

  return isLoadingItems ? (
    <Loader />
  ) : (
    <>
      <Section className="item-list">
        {data?.map((item) => (
          <Item
            item={item}
            handleSelectItem={handleSelectItem}
            checked={isItemChecked(item?.uuid)}
            key={item?.uuid}
            isModal={isModal}
          />
        ))}
      </Section>
      {isModal && <ItemDetails />}
    </>
  )
}

ItemList.defaultProps = {
  data: [],
  itemsSelected: [],
  setItemsSelected: () => {},
  isLoading: false,
}

ItemList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  itemsSelected: PropTypes.arrayOf(PropTypes.string).isRequired,
  setItemsSelected: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default ItemList
